import { aiAxios } from './aiAxios'
import { toDomainHttpClient } from './toDomainHttpClient'

export const domainAiHttpClient = toDomainHttpClient(aiAxios, { forwardMeta: false })
